// extracted by css-extract-rspack-plugin
export default {"loader":"nZ0ve7OE_Mucd3OV"};